import { render, staticRenderFns } from "./EModalEncaminhametoEscolar.vue?vue&type=template&id=af03ad2e"
import script from "./EModalEncaminhametoEscolar.vue?vue&type=script&lang=js"
export * from "./EModalEncaminhametoEscolar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports